export { default } from './promotional-banner';
